/**
 * The rule's identity in the rail (Figma 2:2, 3:3): `RuleHeading` (the rule's name and its citation, the one
 * line), `RuleSummary` and `ChipRow` (the chips of a kind, which are `Chip`s: dark where it is the one the rule is).
 */
import type { ReactNode } from 'react';
import { SPACE, TEXT, WEIGHT, usePalette } from '../theme';

export function RuleHeading({ name, cite }: { name: ReactNode; cite: ReactNode }) {
  const p = usePalette();
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: SPACE.snug, lineHeight: 'normal', flexWrap: 'wrap' }}>
      <span style={{ fontSize: TEXT.control, fontWeight: WEIGHT.medium, color: p.inkSecondary }}>{name}</span>
      <span style={{ fontSize: TEXT.caption, color: p.inkMuted }}>{cite}</span>
    </div>
  );
}

export function RuleSummary({ children }: { children: ReactNode }) {
  const p = usePalette();
  return <p style={{ margin: 0, fontSize: TEXT.body, color: p.ink, lineHeight: 'normal' }}>{children}</p>;
}

/** A row of chips that wraps at the rail's width. */
export function ChipRow({ children, label }: { children: ReactNode; label: string }) {
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', flexWrap: 'wrap', gap: SPACE.tight, alignItems: 'flex-start' }}>
      {children}
    </div>
  );
}
